module.exports = __webpack_public_path__ + "static/img/vote-dialog-bg.83ad06d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vote-dialog-bg.png
// module id = RU/3
// module chunks = 1